// fill in both in order to get proper intellisense
export type BaseDict = {
    NoData: string,
    ShowAll: string,
    HideAll: string,
    SelectedLeaguesLimitReached: string,
    LiveSteaming: string,
    LiveLabel: string,
    CouponLeague: string,
    AllLeagues: string,
    TopLeagues: string,
    CreateCoupon: string
}
export const BaseDict: BaseDict = {
    NoData: "No Data",
    ShowAll: "Show All",
    HideAll: "Hide All",
    SelectedLeaguesLimitReached: "Maximum number of selected leagues reached!",
    LiveSteaming: "LiveStream",
    LiveLabel: "Live",
    CouponLeague: "Coupon Leagues",
    AllLeagues: "All Leagues",
    TopLeagues:"Top Leagues",
    CreateCoupon: "Create Coupon"
}